import { render, staticRenderFns } from "./stationeryRecordAdd.vue?vue&type=template&id=26920c80&scoped=true"
import script from "./stationeryRecordAdd.vue?vue&type=script&lang=js"
export * from "./stationeryRecordAdd.vue?vue&type=script&lang=js"
import style0 from "./stationeryRecordAdd.vue?vue&type=style&index=0&id=26920c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26920c80",
  null
  
)

export default component.exports